import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

// Single application-wide RTK Query API instance
// Consolidate tagTypes from all features that we migrate to rootApi
// Current union: Invites, Groups, Courses
export const rootApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 300,
  tagTypes: [
    'Invite','InviteList','InvitesModalState',
    'Group','GroupList',
    'Courses','CoursePackages',
    'Media','Directory',
    'Dashboard',
    'Auth',
    'Diploma','DiplomaList',
    'Discount','DiscountList',
    'Export',
    'FileUpload',
    'Content',
    'MrWolf','CourseAccess',
    'Statistics','Sales','Analytics','Invitations',
    'Notifications','UnreadCount',
    'Search','Circles','UserGroups','UserCourses',
    'Settings','StoreCurrency',
    'Users','GroupUsers','CourseUsers',
    'User','UserStatistics',
    'Transactions',
    'Webinar',
    'Notes','Note',
    'Section',
    'Quizes','Quiz',
    'Tasks','Task',
    'Course','CourseProgress',
    'Page',
    'Module', // Page modules/content blocks
    'Layout', // Page layout configuration
    'Post','Discussion',
    'NetworkProviders',
    'ClassroomEvent',
    'Campaign','CampaignList','CampaignStats','CampaignRecipients','AudiencePreview','UpsellPlacement',
  ],
  endpoints: () => ({}),
});

